import HoseModel from "./HoseModel";
import HoseTestModel from "./HoseTestModel";

export default class HoseHistoryModel {
  constructor(data = {}) {
    
    let template = {
      hose: null,
      testRecords: null,
      repairRecords: null
    }

    this.data = template;

    if (data.hose) {
      this.data.hose = new HoseModel(data.hose);
      
      this.data.testRecords = [];
      data.testRecords?.forEach(test => {
        this.data.testRecords.push(new HoseTestModel(test));
      });

      //TODO: Add Hose Repair records
    }
  }

  getHose = () => { return this.data.hose; }
  setHose = (value) => { this.data.hose = value;}

  getTestRecords = () => { return this.data.testRecords; }
  setTestRecords = (value) => { this.data.testRecords = value;}

  getRepairRecords = () => { return this.data.repairRecords; }
  setRepairRecords = (value) => { this.data.repairRecords = value;}


  toJson = () =>{
    return JSON.stringify(this.data);
  }

  /** 
   * This is used for application code to confirm 
   * the object is indeed a HoseModel
   */
  getType = () => {
    return "HoseHistoryModel";
  }

}